<script context="module">
    import { writable } from "svelte/store";
    const message = writable("");

    let snackbar;
    export function open(msg) {
        message.set(msg);
        snackbar.open();
    }
</script>

<script>
    import Snackbar, { Label } from "@smui/snackbar";
</script>

<Snackbar bind:this={snackbar} labelText={$message}>
    <Label />
</Snackbar>
